import styled, { css } from 'styled-components';
export const Container = styled.div `
  display: flex;
  flex-direction: row;
  align-items: start;
`;
export const Label = styled.label `
  ${() => css `
    line-height: 1;
  `}
`;
export const CheckBox = styled.input `
  ${({ theme }) => css `
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: ${theme.border.radius.medium};
    appearance: none;
    min-width: 24px;
    height: 24px;
    max-height: 24px;
    border: ${theme.border.width.thin} solid ${theme.color.base.nth1};
    transition: background border 0.3s;
    margin-right: 12px;
    position: relative;
    &:before { 
      content: '';
      width: ${theme.spacing.inline.small};
      height: ${theme.spacing.inline.small};
      border: 1px solid ${theme.color.base.nth4};
      border-top: 0;
      border-left: 0;
      transform: rotate(45deg);
      position: absolute;
      top: 5px;
      opacity: 0;
      transition: 0.3s;
    }
    &:checked {
      background: ${theme.color.brand.tertiary.nth2};
      border: none;
      &:before {
        opacity: 1;
      }
    }
  `}
`;
//# sourceMappingURL=CheckBox.styles.js.map